import React from 'react';

// Styles & Assets
import styles from './DropdownSelector.module.css';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';

// Hooks
import { useState } from 'react';

// Components
import CircleSelector from '../CircleSelector/CircleSelector';

// Language
import { useTranslation } from 'react-i18next';

// Interfaces
interface OptionsInterface {
    id: number,
    name: string,
    check: boolean,
}

interface Props {
    label: string,
    options: OptionsInterface[],
    msgNoOptions?: string
    onChange: (id: number) => void
}

const DropdownSelector = ({ label, options, msgNoOptions, onChange }: Props) => {

    const { t } = useTranslation();

    const [showOptions, setShowOptions] = useState(false);

    return (
        <>
            <button
                onClick={() => setShowOptions(prevOptions => !prevOptions)}
                className={`button ${styles.buttonDropdown}`}>
                <span>{label}</span>
                {showOptions ?
                    <MdKeyboardArrowUp data-testid='arrowup-icon' />
                    :
                    <MdKeyboardArrowDown data-testid='arrowdown-icon' />
                }
            </button>
            <div className={styles.optionsContainer}>
                {showOptions ? options.length > 0 ?
                    options.map(option =>
                        <CircleSelector
                            key={option.id}
                            text={option.name}
                            active={option.check}
                            size={14}
                            handleClick={() => onChange(option.id)}
                        />
                    )
                    :
                    <p>{msgNoOptions ?? t('no_options_available')}</p>
                    : null
                }
            </div>
        </>
    );
};

export default DropdownSelector;